<!--  -->
<template>
  <div class="font">
    <div class="cen">
      <div class="one">
        <span class="left">技术运营支持: 吉林省吉科软信息技术有限公司</span>
        <!-- <span>客户服务热线: 400800400</span> -->
      </div>
      <div>
        <span>Copyright@ {{ year }} All rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      year: new Date().getUTCFullYear(),
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //方法集合
  methods: {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.foot {
  width: 100%;
  height: 4rem;
}
.cen {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  font-size: 0.72rem;
  .one {
    margin-bottom: 0.5rem;
    .left {
      // margin-right: 1rem;
    }
  }
}
</style>
